import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';

interface BottomBarProps {
  totals: {
    totalQuantity: number;
    totalAmount: number;
  };
}

export const BottomBar = ({ totals }: BottomBarProps) => {
  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[220px]',
      fields: [{ name: 't_so_luong', label: 'Tổng số lượng', value: totals.totalQuantity, precision: 6 }]
    },
    {
      className: 'min-w-[240px]',
      fields: [{ name: 't_tien', label: 'Tổng tiền', value: totals.totalAmount, inputClassName: 'text-right' }]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
};

export default BottomBar;
